import { OverrideOrder } from "../../app/miscellaneous/orderAtom";
import { getPartnerPathnameClient } from "../../getPartnerPathnameClient";
import { definitions, operations, paths } from "../generated/orders-model-api";
import { fetchItJson } from "./fetchItJson";
import { FetchOutput } from "./fetchResult";

type Path = paths["/orders"];
type Responses = Path["put"]["responses"];

type Order200Schema = OverrideOrder<Responses["200"]["schema"]>;

export type FetchPutOrderOutput = FetchOutput<
  Order200Schema,
  definitions["ProblemDetails"]
>;

export type FetchPutOrderInput =
  operations["OrderPut"]["parameters"]["body"]["body"];

export async function fetchPutOrder(
  body: FetchPutOrderInput
): Promise<FetchPutOrderOutput> {
  const path: keyof paths = "/orders";

  return fetchItJson<Order200Schema, definitions["ProblemDetails"]>(
    "authorization",
    `${getPartnerPathnameClient(true)}/Market/HostedCart/Orders/v1${path}`,
    {
      method: "PUT",
      body: JSON.stringify(body),
      headers: { "Content-Type": "application/json" },
    }
  ).catch(() => {
    return { tag: "client-error", parsed: { status: 418 } };
  });
}
